module.exports = __webpack_public_path__ + "static/media/youyou61.0d3f290f.png";